import React from 'react';
import cn from 'classnames';
import styles from './LoadingCard.module.css';
import { Card } from '../../../../components/Card';
import LoadingField from '../LoadingField/LoadingField';

const PlaceholderGrid = ({ count = 4 }) => (
  <div className={styles.gridCardColumn}>
    {Array.from({ length: count }, (_, i) => (
      <div key={i} className={styles.gridItem}></div>
    ))}
  </div>
);

const LoadingCard = ({ detailsCard }) => {
  if (detailsCard) {
    return (
      <Card className={cn('vehicle-info-card info-card data', styles.detailsCard)}>
        <LoadingField />
        <LoadingField />
        <LoadingField />
        <LoadingField />
        <LoadingField />
        <LoadingField />
        <LoadingField />
      </Card>
    );
  }
  return (
    <div className={cn('card', styles.card)}>
      <div className={styles.titlePlaceholder}>
        <div className={styles.checkboxPlaceholder}></div>
        <div className={styles.textPlaceholder}></div>
        <div className={styles.statusPlaceholder}></div>
      </div>

      <div className={styles.img}></div>

      <div className="card-body">
        <div className={styles.gridCard}>
          <PlaceholderGrid />
          <PlaceholderGrid />
        </div>

        <div className={styles.buttonCard}>
          <div className={styles.buttonPlaceholder}></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingCard;
